import * as React from 'react';
import Component from '../../../Component';
import Manager from './Manager';

export default class UpcomingNewServiceYear extends Component {

    render() {
        return <Manager filters={this.props.filters} onEmpty={() => { if (this.props.onEmpty) { this.props.onEmpty(); } }} />
    }
}